<script setup></script>

<template>
  <div class="py-5 text-dark">
    <div class="row px-3 m-0">
      <div
        class="col-lg-7 d-flex flex-column justify-content-center items-center text-center text-md-start"
      >
        <div class="col-md-8 mx-auto">
          <h1 class="text-center text-lg-start text-dark" style="letter-spacing: 1px;">
            ¡Simula tu leasing<br />en segundos!
          </h1>
          <p class="text-dark text-center text-md-start text-lg py-3" style="line-height: 22px;">
            Descubre la renta mensual del activo que necesitas. Obtén una vista
            previa rápida y precisa de tus pagos mensuales.<br />¡No esperes
            más, conoce tu cuota mensual hoy mismo!
          </p>

          <a
            class="text-dark fw-bold text-center text-uppercase"
            style="font-size: 12px; letter-spacing: 1px;"
            href="https://ventusleasing.mx/productos"
            target="_blank"
            ><u class="">Aprende más acerca del arrendamiento puro aquí</u></a
          >
        </div>
      </div>

      <div class="col-lg-5">
        <router-view />
      </div>
    </div>
    <div></div>
  </div>
</template>

<style scoped>
.bg-dark {
  background: #000 !important;
}

.text-dark {
  color: #000 !important;
}

.bg-warning {
  background: #f7bf00 !important;
}
</style>
